function getVariant(rated, total) {
    if (!total) return 'secondary'
    const percent = Math.round(rated / total * 100)
    if (percent < 50) return 'warning'
    if (percent < 75) return 'info'
    return 'success'
}

function getTag(rated, total) {
    return (rated || 0) + ' / ' + (total || 0)
}

export default [
    {
        header: 'Голосования',
        action: 'vote',
        resource: 'video',
    },
    {
        title: 'Альбомы RU',
        route: 'vote-albums-ru',
        icon: 'DiscIcon',
        action: 'vote',
        resource: 'album',
        tag: getTag(localStorage.getItem('stats.albums.ru'), localStorage.getItem('stats.albums.ru_all')),
        tagVariant: getVariant(localStorage.getItem('stats.albums.ru'), localStorage.getItem('stats.albums.ru_all')),
    },
    {
        title: 'Альбомы EN',
        route: 'vote-albums-en',
        icon: 'DiscIcon',
        action: 'vote',
        resource: 'album',
        tag: getTag(localStorage.getItem('stats.albums.en'), localStorage.getItem('stats.albums.en_all')),
        tagVariant: getVariant(localStorage.getItem('stats.albums.en'), localStorage.getItem('stats.albums.en_all')),
    },
    {
        title: 'Песни RU',
        route: 'vote-songs-ru',
        icon: 'MusicIcon',
        action: 'vote',
        resource: 'song',
        tag: getTag(localStorage.getItem('stats.songs.ru'), localStorage.getItem('stats.songs.ru_all')),
        tagVariant: getVariant(localStorage.getItem('stats.songs.ru'), localStorage.getItem('stats.songs.ru_all')),
    },
    {
        title: 'Песни EN',
        route: 'vote-songs-en',
        icon: 'MusicIcon',
        action: 'vote',
        resource: 'song',
        tag: getTag(localStorage.getItem('stats.songs.en'), localStorage.getItem('stats.songs.en_all')),
        tagVariant: getVariant(localStorage.getItem('stats.songs.en'), localStorage.getItem('stats.songs.en_all')),
    },
    {
        title: 'Клипы RU',
        route: 'vote-videos-ru',
        icon: 'YoutubeIcon',
        action: 'vote',
        resource: 'video',
        tag: getTag(localStorage.getItem('stats.videos.ru'), localStorage.getItem('stats.videos.ru_all')),
        tagVariant: getVariant(localStorage.getItem('stats.videos.ru'), localStorage.getItem('stats.videos.ru_all')),
    },
    {
        title: 'Клипы EN',
        route: 'vote-videos-en',
        icon: 'YoutubeIcon',
        action: 'vote',
        resource: 'video',
        tag: getTag(localStorage.getItem('stats.videos.en'), localStorage.getItem('stats.videos.en_all')),
        tagVariant: getVariant(localStorage.getItem('stats.videos.en'), localStorage.getItem('stats.videos.en_all')),
    },
    {
        title: 'Итоги года RU',
        route: 'year-baskets-ru',
        icon: 'AwardIcon',
        action: 'vote',
        resource: 'basket',
    },
    {
        title: 'Итоги года EN',
        route: 'year-baskets-en',
        icon: 'AwardIcon',
        action: 'vote',
        resource: 'basket',
    },
]
